import { Permissions } from '../shared/constants/permissions';
import { Permission } from '../store/permissions/permissions.reducer';

export const filterPermissions = (permission: Permission, isAdmin: boolean) => {
  // The 'whitelist' permission isn't displayed in the normal way
  return permission.key !== Permissions.Whitelist;
};

export default filterPermissions;
